import React, { useState } from 'react';
import './SubscribeModal.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const SubscribeModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email.trim()) {
      setError('Please enter your email address.');
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await fetch(`${API_BASE_URL}/subscriptions/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });

      const data = await response.json();
      if (!response.ok) {
        setError(data.error || 'Something went wrong. Please try again.');
        return;
      }

      setIsSubscribed(true);
    } catch (err) {
      setError('Failed to subscribe. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setEmail('');
    setError('');
    setIsSubscribed(false);
    onClose();
  };

  return (
    <div className="subscribe-modal-overlay" onClick={handleClose}>
      <div className="subscribe-modal" onClick={(e) => e.stopPropagation()}>
        <button className="subscribe-modal-close" onClick={handleClose} aria-label="Close">
          ×
        </button>

        {!isSubscribed ? (
          <>
            <div className="subscribe-modal-icon">✉️</div>
            <h2 className="subscribe-modal-title">Subscribe to Daily Health</h2>
            <p className="subscribe-modal-description">
              Get the latest health and wellness articles delivered directly to your inbox.
            </p>

            <form className="subscribe-modal-form" onSubmit={handleSubmit}>
              <input
                type="email"
                className="subscribe-modal-input"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isSubmitting}
                autoComplete="email"
                autoFocus
              />
              {error && <p className="subscribe-modal-error">{error}</p>}
              <button type="submit" className="subscribe-modal-btn" disabled={isSubmitting}>
                {isSubmitting ? 'Subscribing…' : 'Subscribe'}
              </button>
            </form>

            <p className="subscribe-modal-legal">
              By subscribing, you agree to our{' '}
              <a href="/terms-of-use" target="_blank" rel="noopener noreferrer">
                Terms of Use
              </a>{' '}
              and{' '}
              <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
              .
            </p>
          </>
        ) : (
          <>
            <div className="subscribe-modal-icon">🎉</div>
            <h2 className="subscribe-modal-title">Thank You for Subscribing!</h2>
            <p className="subscribe-modal-description">
              You're now part of the Daily Health community. We'll send you the best health
              and wellness content straight to your inbox.
            </p>
            <button className="subscribe-modal-btn" onClick={handleClose}>
              Close
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default SubscribeModal;
